import {
  AUTH_EVENTS,
  getSessionReadyFromSso,
  type SsoContextValue,
} from '@discover-frontend/auth';

const SESSION_WAIT_MS = 15000;
const SESSION_POLL_MS = 100;

type GetSso = () => SsoContextValue | null | undefined;

export const waitForSessionReady = (
  getSso: GetSso,
  deadlineMs: number = SESSION_WAIT_MS
): Promise<void> =>
  new Promise((resolve, reject) => {
    const deadline = Date.now() + deadlineMs;
    let intervalId: ReturnType<typeof setInterval> | undefined;

    const cleanup = () => {
      window.removeEventListener(AUTH_EVENTS.SESSION_RECOVERED, onRecovered);
      window.removeEventListener(AUTH_EVENTS.SESSION_LOCK, onLock);
      if (intervalId) clearInterval(intervalId);
    };

    const check = () => {
      const sso = getSso();

      if (sso?.sessionPhase === 'locked') {
        cleanup();
        reject(new Error('locked'));
        return;
      }

      if (getSessionReadyFromSso(sso)) {
        cleanup();
        resolve();
        return;
      }

      if (Date.now() >= deadline) {
        cleanup();
        reject(new Error('timeout'));
      }
    };

    const onRecovered = () => check();
    const onLock = () => {
      cleanup();
      reject(new Error('locked'));
    };

    window.addEventListener(AUTH_EVENTS.SESSION_RECOVERED, onRecovered);
    window.addEventListener(AUTH_EVENTS.SESSION_LOCK, onLock);
    intervalId = setInterval(check, SESSION_POLL_MS);
    check();
  });
